import { render } from "./data-bs-theme.vue?vue&type=template&id=ec91888c&scoped=true&ts=true"
import script from "./data-bs-theme.vue?vue&type=script&lang=ts"
export * from "./data-bs-theme.vue?vue&type=script&lang=ts"

import "./data-bs-theme.vue?vue&type=style&index=0&id=ec91888c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec91888c"]])

export default __exports__